export const REVIEWS_LIST_TEST_ID = 'REVIEWS_LIST_TEST_ID';
export const REVIEWS_LIST_SKELETON_TEST_ID = 'REVIEWS_LIST_SKELETON_TEST_ID';
